module.exports = __webpack_public_path__ + "static/media/tension1.b95bb0ab.webp";